export const MOVO_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "firstname",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Point",
    Footer: "Point",
    accessor: "point",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionDate",
  },
   {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const MOVO_VOUCHER_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Voucher Code",
    Footer: "Voucher Code",
    accessor: "vouchercode",
  },
  {
    Header: "Voucher Name",
    Footer: "Voucher Name",
    accessor: "voucherName",
  },
  {
    Header: "Value",
    Footer: "Value",
    accessor: "value",
  },
  {
    Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "expiredate",
  },
];